import { useState, Fragment, Dispatch, SetStateAction } from "react";
import classNames from "classnames";
import styles from "./MDNav.module.scss";

import { PlusIcon } from "../icons";
import { FormattedMessage } from "react-intl";
import { RoutePaths } from "pages/routePaths";

import { ChatRoute } from "pages/ChatPage";
import useRouter from "hooks/useRouter";
import { useAppNotification } from "hooks/services/AppNotification";
import {
  IChat, 
   setPrivateChat,
  startNewChat, clearhistoryMessages, SaveSelectedThread, setIsEditing, DeleteS3Link, deleteSingleChatHistory, removeMultipleChat,
  setIsModalOpen, EmptyUploadedFiles,
} from "redux/actions";
import { useSelector } from "redux/hooks";
import { LogoutIcon } from "../AccountNav/icons";
import { logout } from "redux/actions";
import { Setting } from "../ChatNav/icons/setting";
import { Link } from "react-router-dom";
import { Credits } from "../ChatNav/components/Credits";
import MixpanelAnalytics from "utils/mixpanel";
import { Loader } from "components/Loader";
import { SaveThreadInfo } from "utils/constants";
import { useThreadsHistoryContext } from "hooks/ThreadHistoryContext";
import { IncognitoMode } from "../ChatNav/icons/IncognitoMode";

import { removeQuotes } from "utils/functions";
import { AlertNotification } from "../ChatNav/components/AlertNotification/AlertNotification";
interface IProps {
  onStartNewChat?: ({ toChat }: { toChat: boolean }) => void;
  toggleChatModelsModel?: () => void;
  setChatSetting?: Dispatch<SetStateAction<boolean>>;
  chatItem?: IChat;
  fileS3Link?: string[];
  isAnswerComplete?: boolean;
}

export const MDNav = ({
  setChatSetting,
  fileS3Link,
  isAnswerComplete,
}: IProps) => {

  const { onChangeChat, } = useThreadsHistoryContext();
  const { pathname, includeRoute, push } = useRouter();
  const { triggerNotification } = useAppNotification();
  const userDetail = useSelector((state) => state.authReducer.userDetail);
  const themeMode = useSelector((state) => state.authReducer.theme);
  const isShareChat = window.location.pathname.includes("share-chat");

  const lang = userDetail?.user?.language ? userDetail?.user?.language : "en";
  const Id = pathname.split("/")[2];

  const { newMessages, PrivateChat, RememberTopic, loadChatTopic } = useSelector((state) => state.chatReducer);
  const { currentConversation, selectedThread, isEditing, searchWsQuery, isSearchActive } = useSelector((state) => state.workSpaceReducer);
  const pathParts = pathname.split("/").filter(Boolean);
  // Parse path to determine which component to render
  const isWorkspacePath = pathParts[0] === "workspaces";
  const hasThreadId = pathParts.includes("thread") && pathParts.length > pathParts.indexOf("threads") + 1;

  const renderThreadsContent = isWorkspacePath && hasThreadId;

   const workSpace = pathname.includes("/thread");
  const isHome = pathname.includes("/workspaces/new");
  const [isloading, setIsloading] = useState<boolean>(false);
  const isChat = pathname.includes("/chat");

  const onLogout = () => {
    setIsloading(true);
    MixpanelAnalytics.trackLogout();
    logout()
      .then(() => {
        localStorage.removeItem('email');
        window.postMessage({ logout: true });
        MixpanelAnalytics.reset();
        setIsloading(false);
      })
      .catch((err: any) => {
        triggerNotification({ message: err?.data?.message, type: "error" });
        setIsloading(false);
      });
  };

  const handleRedirectBack = () => {
    if (renderThreadsContent || (newMessages.length > 0 && workSpace)) {
      SaveSelectedThread(SaveThreadInfo);
      startNewChat();
      clearhistoryMessages();
      push(`/${RoutePaths.Workspaces}/${renderThreadsContent ? selectedThread.ws_id : Id}`)
    }
    else push(`/${RoutePaths.Workspaces}`)
    setIsEditing(false);
  }

  const getTimeBasedGreeting = () => {
    const currentHour = new Date().getHours();

    if (currentHour >= 5 && currentHour < 12) {
      return <FormattedMessage id="chatpage.greeting.morning" defaultMessage="Good morning" />;
    } else if (currentHour >= 12 && currentHour < 18) {
      return <FormattedMessage id="chatpage.greeting.afternoon" defaultMessage="Good afternoon" />;
    } else if (currentHour >= 18 && currentHour < 22) {
      return <FormattedMessage id="chatpage.greeting.evening" defaultMessage="Good evening" />;
    } else {
      return <FormattedMessage id="chatpage.new.heading" />;
    }
  };

  const getFirstName = (fullName: string | undefined) => {
    if (!fullName) return "";
    return fullName.split(" ")[0];
  };

  const handleDeleteS3Link = () => {
    fileS3Link?.map((file) => {
      DeleteS3Link(file);
    });
  };
  const handleIncognitoMode = () => {
    const currentPath = window.location.pathname;
    const pathSegments = currentPath.split("/");
    const chatIdFromUrl = pathSegments[pathSegments.length - 2];

    if (Number(chatIdFromUrl)) {
      deleteSingleChatHistory(Number(chatIdFromUrl));
      removeMultipleChat([Number(chatIdFromUrl)]);
      sessionStorage.removeItem("privateChatActive");
      sessionStorage.removeItem("PrivateChatId");
    }

    sessionStorage.setItem("privateChatActive", JSON.stringify(true));
    localStorage.setItem("previousPrivateChat", JSON.stringify(true));
    handleDeleteS3Link();
    push(`/${RoutePaths.Home}`);
    startNewChat();
    onChangeChat?.();
    setPrivateChat(false);
  };

  const pathSegments = pathname?.split("/") || [];
  const pathSegment = pathSegments[2] || "";
  const displayName = pathSegment ? `My ${pathSegment.charAt(0).toUpperCase()}${pathSegment.slice(1)}` : "";

  if (includeRoute(RoutePaths.Chat) || includeRoute(RoutePaths.Workspaces)) {
    return (
      <Fragment>
        <div
          className={classNames(styles.container, {
            [styles.light]: themeMode === "light",
            [styles.dark]: themeMode === "dark",
          })}
        >
          {isShareChat && (
            <Link
              to="/"
              className={styles.headerLogo}
              data-testid="share-header-logo"
            >
              <img src={require("../../../Sidebar/logo.png")} />
            </Link>
          )}

          <div className={classNames("font-inter flex gap-[14px] items-center min-w-0 pr-2 flex-1", styles.LogoContainer, {
          })}>

            {isHome && (
              (searchWsQuery || isSearchActive) ? (<div
                className={classNames("font-inter", styles.GrettingStyle, {
                  [styles.light]: themeMode === "light",
                  [styles.dark]: themeMode === "dark",
                })}
              > <FormattedMessage id="workspace.search" /><span>&nbsp;"{searchWsQuery}"</span></div>) : (
                <div
                  className={classNames("font-inter", styles.GrettingStyle, {
                    [styles.light]: themeMode === "light",
                    [styles.dark]: themeMode === "dark",
                  })}
                >
                  {getTimeBasedGreeting()},{" "}
                  {userDetail?.user?.name && (
                    <span>&nbsp;{getFirstName(userDetail.user.name)}</span>
                  )}
                </div>
              )
            )}

            {PrivateChat &&
              <div className={classNames("cursor-pointer", styles.WorkSpace, styles.LogoContainer, {
                [styles.light]: themeMode === "light",
                [styles.dark]: themeMode === "dark",
              })} onClick={handleIncognitoMode}>
                <div className="flex items-center gap-[16px]">
                  <FormattedMessage id="private.chat.navbar" />
                  <IncognitoMode />
                </div>
              </div>}

            {/* For chat mode, show RememberTopic with edit icon */}
            {isChat && !isEditing && !PrivateChat && (
              <div className={classNames("flex items-center gap-2 min-w-0 flex-1 pr-[2px] ml-1", {
              })}>
                <div className={classNames(styles.WorkSpace, {
                  [styles.light]: themeMode === "light",
                  [styles.dark]: themeMode === "dark",
                })}>
                  {!RememberTopic && loadChatTopic ? (
                    <div className="flex item-center mt-1"><Loader /></div>
                  ) : (
                    removeQuotes(RememberTopic)
                  )}
                </div>
              </div>
            )}

            {!isHome && !isChat && (includeRoute(RoutePaths.Workspaces) || (workSpace)) && (
              <div
                className={classNames(
                  "flex items-center gap-2 w-full"
                )}
              >
                <div
                  className={classNames(styles.WorkSpace, {
                    [styles.light]: themeMode === "light",
                    [styles.dark]: themeMode === "dark",
                    [styles.cursor]: Id,
                  })}
                  onClick={handleRedirectBack}
                  data-testid="sidebar-chat-newchat-workspace">{renderThreadsContent ?
                    selectedThread.ws_name : (workSpace) && currentConversation?.name
                      ? currentConversation.name
                      : <FormattedMessage id="sidebar.chat.newChat.workspace" />}
                </div>
              </div>
            )}

          </div>

          <div
            className={
              !isShareChat ? styles.menuContainer : styles.menuShareContainer
            }
          >
            {!isShareChat && (
              <>

                <AlertNotification mdNav={true} />
                {!includeRoute(RoutePaths.Workspaces) && (
                  <>
                    <div
                      data-testid="md-setting-new-chat"
                      className={styles.icon}
                      onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (isAnswerComplete || isAnswerComplete === undefined) {

                          // If it's a private chat, execute the delete API
                          if (PrivateChat) {
                            const currentPath = window.location.pathname;
                            const pathSegments = currentPath.split("/");
                            const chatIdFromUrl = pathSegments[pathSegments.length - 2];

                            if (Number(chatIdFromUrl)) {
                              deleteSingleChatHistory(Number(chatIdFromUrl));
                              removeMultipleChat([Number(chatIdFromUrl)]);
                              sessionStorage.removeItem("PrivateChatId");
                            }
                            handleDeleteS3Link();
                            push(`/${RoutePaths.Chat}/${ChatRoute.New}`);
                            startNewChat();
                            onChangeChat?.();
                          }
                          setIsModalOpen(true);
                          EmptyUploadedFiles();
                        }

                      }}
                    >
                      <PlusIcon color="#71717a" />
                    </div>
                  </>
                )}

                <div
                  data-testid="md-chat-setting-icon"
                  className={`${styles.icon} ${styles.settingIcon}`}
                  onClick={() =>
                    setChatSetting!(true)}
                >
                  <Setting />
                </div>
                <div>
                  <Credits mdNav={true} />
                </div>
              </>
            )}
            {isShareChat && (
              <div className={styles.shareChatbtn}>
                <button
                  data-testid="share-chat-try-deftgpt-free"
                  className={styles.shareChatTryBtn}
                  onClick={() => push(`/${lang}/${RoutePaths.Signup}`)}
                >
                  <FormattedMessage id="share.chat.header" />
                </button>
              </div>
            )}
          </div>
        </div>
      </Fragment>
    );
  } else {
    return (
      <Fragment>
        <div
          className={classNames(styles.container, {
            [styles.light]: themeMode === "light",
            [styles.dark]: themeMode === "dark",
            [styles.teamMdNav]: includeRoute(RoutePaths.Team),
          })}
        >
          {(includeRoute(RoutePaths.Team) || includeRoute(RoutePaths.Account) || includeRoute(RoutePaths.CurrentPlan)) && (
            <div
              className={classNames(styles.pageTitle, {
                [styles.account]: includeRoute(RoutePaths.Account),
              })}
            >

              {includeRoute(RoutePaths.Team)
                ? "My Organization"
                : includeRoute(RoutePaths.CurrentPlan)
                  ? "Current Plan"
                  : displayName
              }
            </div>
          )}
          {!includeRoute(RoutePaths.Team) && <div className={styles.placeholder}></div>}
          {(includeRoute(RoutePaths.Account) || includeRoute(RoutePaths.Team) || includeRoute(RoutePaths.CurrentPlan)) && (
            <button
              className={classNames(styles.logoutButton, {
                [styles.light]: themeMode === "light",
                [styles.dark]: themeMode === "dark",
              })}
              onClick={onLogout}
              disabled={isloading}
              id="logout"
              data-testid='account-setting-logout'
            >
              <div
                className={classNames(styles.btnContent, {
                  [styles.light]: themeMode === "light",
                  [styles.dark]: themeMode === "dark",
                })}
              >
                <LogoutIcon theme={themeMode} />
              </div>
            </button>
          )}
        </div>

      </Fragment>
    );
  }
};